export default {
  root: {
    fontSize: '0.975rem'
  },
  extended: {
    height: '55px',
    borderRadius: '30px',
    padding: '0 30px'
  }
};